import cn from 'classnames';

const StatusTag = ({
  backgroundColor,
  icon,
  isBasketStatus = false,
  text,
  textColor = 'text-charcoal-90',
  textSize = 'h7',
}) => {
  const tagBackgroundColor = isBasketStatus ? '' : backgroundColor;
  return (
    <span
      className={cn(
        textSize,
        'rounded',
        isBasketStatus ? 'p-0' : 'px-2 py-1',
        tagBackgroundColor,
        textColor,
        !isBasketStatus && 'uppercase'
      )}
    >
      <div className="flex flex-row items-center gap-1.5">
        {icon}
        <span className="whitespace-nowrap">{text}</span>
      </div>
    </span>
  );
};

StatusTag.propTypes = {
  backgroundColor: PropTypes.string,
  icon: PropTypes.element,
  isBasketStatus: PropTypes.bool,
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

export default StatusTag;
